/**
 * エントリーページ ドロップダウンメニュー
 */
export class Accordion {

  /**
   * wpcf7-select
   */
  private m_element: JQuery;

  /**
   * liの選択num保存用
   */
  private m_old_num: number;

  /**
   * default-selectのtext保存用
   */
  private m_default_text: string;

  /**
   * コンストラクタ
   */
  constructor(element: string) {
    this.m_old_num = -1;
    this.m_default_text = '';
    this.m_element = $(element);

    if (! this.m_element[0]) {
      return;
    }

    this.Init();
    this.AccordionMenu();
  }

  /**
   * メンバ関数
   */
  private Init() {
    if ($(window).width() > 999) {
      this.m_element.closest('td').css({'display': 'flex'});
    }

    //DOM追加 アコーディオン用箱
    this.m_element.after(
      "<div class='selectBox'><ul class='selectList'><li class='default-select'><span>選択してください</span><div class='arrow'></div></li><li><ul class='inner-accordion'></ul></li></ul> </div>"
    );
    // DOM追加 アコーディオン箱内にselectのoptionの数だけli追加
    this.m_element.each((i: any , p_elm: any) => {
       $(p_elm).children('option').each((i: any, elem: any) => {
        const val = $(elem).val();

        if (val) {
          $(elem).parent().next().find('.inner-accordion').append('<li><span>' + val + '</span></li>');
        }
      });
    });
  }

  private AccordionMenu() {
    // 最初’選択してください’が押された時
    $('.default-select').each((i: any, elm: any) => {
      // default-select保存
      this.m_default_text = $(elm).children('span').text();
      console.log(this.m_default_text);
      $(elm).on('click',function(event: any) {
        const next = $(elm).next();

        // toggle 状態付与
        next.toggleClass('is-open');

        // is-open の時だけ menu 展開
        if (next.attr('class') == 'is-open') {
          // menu展開
          next.find('.inner-accordion').css({'display': 'block', 'border-width': '1px'});
          next.find('.inner-accordion li').height(45);
          // arrow 回転
          $(event.currentTarget).find('.arrow').addClass('rotate');
        } else {
          // menu格納
          next.find('.inner-accordion li').height(0);
          next.find('.inner-accordion').css({'display': 'none', 'border-width': '0px'});
          // arrow 回転
          $(event.currentTarget).find('.arrow').removeClass('rotate');
        }
      });
    });

    // 選択した時
    $('.inner-accordion li').each((i: any, elm: any) => {
      // どれかがクリックされた
      $(elm).on('click',(event: any) => {
        // 選択されたold_i = i の時 defaultを元の状態に
        var val;

        if (this.m_old_num == i) {
          // defaultを元の状態
          $(event.currentTarget).closest('.selectList').find('.default-select span').html(this.m_default_text);
          // selected 操作
          val = this.m_default_text;
        } else {
          // 値をdefaultに上書き
          $(event.currentTarget).closest('.selectList').find('.default-select span').html($(event.currentTarget).text());
          this.m_old_num = i;
          val = $(event.currentTarget).text();
        }

        // menu閉じる
        $(event.currentTarget).parent().find('li').height(0);
        $(event.currentTarget).parent('.inner-accordion').css({'border-width': '0px', 'display': 'none'});
        // arrow 回転
        $(event.currentTarget).closest('.selectList').find('.arrow').removeClass('rotate');
        // is-open 外す
        $(event.currentTarget).closest('.is-open').removeClass('is-open');
        // selected 操作
        $(event.currentTarget).closest('.select').find('.wpcf7-select').val(val);
      });
    });
  }

}
